import { render } from "./TvmCurrentVehicle.vue?vue&type=template&id=d4b362fc&scoped=true"
import script from "./TvmCurrentVehicle.vue?vue&type=script&lang=js"
export * from "./TvmCurrentVehicle.vue?vue&type=script&lang=js"

import "./TvmCurrentVehicle.vue?vue&type=style&index=0&id=d4b362fc&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b362fc"],['__file',"src/components/ChatWidget/SlideOutPanel/TvmCurrentVehicle/TvmCurrentVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4b362fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4b362fc', __exports__)) {
    api.reload('d4b362fc', __exports__)
  }
  
  module.hot.accept("./TvmCurrentVehicle.vue?vue&type=template&id=d4b362fc&scoped=true", () => {
    api.rerender('d4b362fc', render)
  })

}


export default __exports__